import script from "./CourseCard.vue?vue&type=script&setup=true&lang=js"
export * from "./CourseCard.vue?vue&type=script&setup=true&lang=js"

import "./CourseCard.vue?vue&type=style&index=0&id=5791091c&scoped=true&lang=stylus"

import exportComponent from "C:\\D\\workspace\\idea\\tkt-web\\camee-sport-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5791091c"]])

export default __exports__